module.exports = __webpack_public_path__ + "static/img/zgdz.c8171bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zgdz.png
// module id = XK9R
// module chunks = 0